<template>
  <v-app-bar
    app
    class="AppHeader white--text"
    color="primary"
    :aria-hidden="showSettingsModal && showSettings"
  >
    <div class="logoTruncate">
      <img alt="logo" src="@/assets/bb-logo.png" width="50" height="50"/>
    </div>
    <h2 class="v-toolbar__title">Emergency Assistance Staff Portal</h2>
    <div class="flex-grow-1"></div>

    <div class="controls">

      <AppHelpMenu />
      <AppProfileMenu />
    </div>
  </v-app-bar>
</template>

<script>
//import fieldHelperMixin from '@/helpers/fieldHelperMixin'
import AppHelpMenu from '@/components/app/AppHelpMenu'
import AppProfileMenu from '@/components/app/AppProfileMenu'

export default {
  name: 'AppHeader',
  //mixins: [fieldHelperMixin],
  components: {
    AppHelpMenu,
    AppProfileMenu,
  },
  data() {
    return {
      showSettings: false
    }
  },
  computed: {

    showSettingsModal() {
      return true;
    }
  },
  methods: {
    settingsOpened(opened) {
      this.$emit('fullScreenModalOpened', opened)
    }
  }
}
</script>

<style scoped lang="scss">
.AppHeader {
  ::v-deep button.v-btn.circular-btn {
    border: none;
    width: 2.8rem;
    height: 2.8rem;
    &:focus {
      box-shadow: 0 0 0 2px $color-focus;
    }
  }

  padding: 0 0 0 1rem;

  &.AppHeader--training {
    background-color: $color-training !important;
    border-color: $color-training !important;
  }

  &__pi-link {
    color: $color-training;
    background-color: #fff;
    margin-left: 2rem;
    padding: 0 1rem;
    height: 2.5rem;
    border-radius: 1.5rem;
  }

  .logoTruncate {
    overflow: hidden;
    margin-right: 1em;
  }

  h1 {
    font-weight: normal;
  }

  h2.v-toolbar__title {
    margin-bottom: 0;
  }

  .controls {
    text-align: right;

    a {
      color: #fff;
    }
  }

  .userIcon {
    margin-right: 0.5em;
    opacity: 0.5;
  }
}

::v-deep .training-dropdown {
  margin-left: 1rem;
}

.help {
  line-height: 1;
  font-size: 1.5rem;
  vertical-align: middle;
  display: inline-block;
  .icon {
    border: 1px solid;
    margin: 0;
  }
}

::v-deep .v-toolbar__content {
  width: 100%;
  display: -webkit-box;
}

.settingsIcon {
  border: none;
}
@media only screen and (max-width: 800px) {
  .AppHeader .controls {
    width: 650px;
  }
}
</style>
